// extracted by mini-css-extract-plugin
export default {"root":"FloTable_root__QPa4D","headerTd":"FloTable_headerTd__JAcMY","scrollable":"FloTable_scrollable__hQ2O+","customWidths":"FloTable_customWidths__bXpv0"};